import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import DetalheImportacaoClienteModel from '../../../../models/importacao-cliente/detalhe-importacao-cliente.model';
import { NotificacaoDetalhe, RootDetailNotification } from '../../../../models/notificacao/notificacao-detalhe.model';
import { LoadingService } from '../../../../util/loader.service';
import { NotificacaoService } from '../../notificacao/notificacao.service';
import { ImportarClienteService } from '../importar-cliente.service';
import { ModalEditarClienteImportacaoComponent } from '../modal-editar-cliente-importacao/modal-editar-cliente-importacao.component';
const swal = require('sweetalert');


@Component({
  selector: 'app-visualizar-importacao-cliente',
  templateUrl: './visualizar-importacao-cliente.component.html',
  styleUrls: ['./visualizar-importacao-cliente.component.scss']
})
export class VisualizarImportacaoClienteComponent implements OnInit {
  id: any;

  page = {
    limit: 10,
    count: 0,
    offset: 0,
    descricao: "",
    ativo: true,
  };
  dados: DetalheImportacaoClienteModel
  edicao: boolean = false;
  selected = [];
  rows: Object[] = [];
  mesagensGrid = {
    'emptyMessage': 'Nenhum dado para exibir',
    'totalMessage': 'Total de registros',
    'selectedMessage': 'Selecionado'
  };
  registroSelecao = [];
  public modalRef: BsModalRef;
  parametroConsulta: string;


  constructor(
    public service: ImportarClienteService,
    private route: ActivatedRoute,
    private routerNavigate: Router,
    public loader: LoadingService,
    private modalService: BsModalService) {
    this.dados = new DetalheImportacaoClienteModel()
    this.id = this.route.snapshot.paramMap.get("id");
    this.reloadTable();
  }

  ngOnInit() {
  }

  reloadTable() {
    this.loader.show("body");
    this.service.ObterInformacoes(this.page, this.id).subscribe(itens => {

      this.dados = itens as DetalheImportacaoClienteModel;
      if (this.dados != null) {
        this.page.count = this.dados.clientes.count;
        this.rows = this.dados.clientes.rows;
      }
      this.loader.hide("body");
    });
  }
  limparSelecionados() {
    this.registroSelecao = [];
    this.selected = [];



    this.onSelect({ selected: [] });


    var inputs = document.getElementsByTagName('input');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('type') == 'checkbox') {
        inputs[i].checked = false;
      }
    }
  }
  pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
    this.page.offset = pageInfo.offset;
    this.service.ObterInformacoes(this.page, this.id).subscribe(itens => {

      this.dados = itens as DetalheImportacaoClienteModel;
      if (this.dados != null) {
        this.page.count = this.dados.clientes.count;
        this.rows = this.dados.clientes.rows;
      }
      this.loader.hide("body");
    });
  }
  onSelect(event) {
    let itens = event.selected;

    let itensSemduplicacao = itens.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null));

    let itemSerRemovido = this.pegarDiferenca(itens, itensSemduplicacao);
    try {
      itens = this.removerItem(itensSemduplicacao, itemSerRemovido);
    } catch (error) {
      //ignore, tudo certo
    }
    this.selected = itens;
    event.selected = itens;

    if (event.selected.length > 0) {
      this.registroSelecao = event.selected;

    } else {

    }
  }
  limparConsultaRapida() {
    this.page.descricao = "";
    this.parametroConsulta = "";
    this.page.offset = 0;
    this.page.limit = 10;
    this.reloadTable();
  }
  consultaRapida() {

    if (this.parametroConsulta != null && this.parametroConsulta.length > 3) {
      this.page.descricao = this.parametroConsulta;
      this.reloadTable();
    } else if (this.parametroConsulta == null || this.parametroConsulta.length == 0) {
      this.limparConsultaRapida();
    }
  }
  editar(event) {

    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      this.loader.show("body");
      this.service.detalharInformacaoCliente(this.registroSelecao[0].id_cliente_empresa).subscribe(itens => {

        this.loader.hide("body");

        const config: ModalOptions = {
          backdrop: 'static',
          keyboard: false,
          animated: true,
          class: 'modal-lg',
          // size: 'lg', // sm, md, lg
          ignoreBackdropClick: true,
          initialState: {
            cliente: itens
          }
        };
        this.modalRef = this.modalService.show(ModalEditarClienteImportacaoComponent, config);

        this.modalRef.content.onClose.subscribe(result => {
          this.limparSelecionados();
          this.reloadTable();


        });
      });
    }

  }
  marcarCheck(codigo) {

    let x = false;
    this.selected.forEach(item => {
      if (item.id_importacao_cliente == codigo) {
        x = true;
      }
    });
    return x;
  }

  removeItemDuplicado(array) {
    array.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null))
    return array;
  }

  removerItem(array, item) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].id_importacao_cliente == item[0].id_importacao_cliente) {
        array.splice(i, 1);
      }
    }

    return array;
  }

  pegarDiferenca(r1, r2) {
    let r3 = r1.filter(a => !r2.includes(a));
    return (r3);
  }

}
